import { useTranslate } from "@tolgee/react";
import { useMemo } from "react";
import {
	type OrderType,
	orderTypeOptions,
} from "./constants/order-form.constants.ts";
import { OrderFormSelect } from "./order-form-select.tsx";

type Props = {
	value: OrderType;
	onValueChange: (nextValue: OrderType) => void;
};

export function OrderTypeSelect({ value, onValueChange }: Props) {
	const { t } = useTranslate();

	const options = useMemo(
		() =>
			orderTypeOptions.map((opt) => ({
				value: opt.value,
				label: t(opt.labelKey),
			})),
		[t],
	);

	return (
		<OrderFormSelect
			ariaLabel="Order type"
			options={options}
			itemClassName="justify-center text-center"
			onValueChange={onValueChange}
			triggerClassName="relative justify-center [&_[data-slot=select-value]]:flex-none [&_[data-slot=select-value]]:justify-center [&_[data-slot=select-value]]:text-center [&_[data-slot=popover-trigger-icon]]:absolute [&_[data-slot=popover-trigger-icon]]:right-3 [&_[data-slot=popover-trigger-icon]]:ml-0"
			value={value}
		/>
	);
}
